import { render, staticRenderFns } from "./ServiceCase.vue?vue&type=template&id=3c4c7542&scoped=true"
import script from "./ServiceCase.vue?vue&type=script&lang=js"
export * from "./ServiceCase.vue?vue&type=script&lang=js"
import style0 from "./ServiceCase.vue?vue&type=style&index=0&id=3c4c7542&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_2aqslel7prtkk4onzp5d3vudie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4c7542",
  null
  
)

export default component.exports